import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Table,
  Row,
  Col,
  Input
} from 'reactstrap';
import { Scatter } from 'react-chartjs-2';

/*import chartOptions from './utils/chartOptions';
import chartData from './utils/chartData';*/
import OutputCalc from '../../../../../../../../components/UIComponents/Fields/OutputCalc';
import optionsAutreUnits from '../../../../../../../../utils/units/optionsAutreUnits';
import optionsForceUnits from '../../../../../../../../utils/units/optionsForceUnits2';

const Shear = ({
  shear,
  steel
}) => {
  return (
    <Container className="geometry">
      <br />
      <Row>
        <Col md={6}>
          {/* <div className="chartContainer">
            <Scatter
              className="chart"
              width={500}
              height={500}
              data={chartData(steel.sectionext, steel.sectionint, sectionData)}
              options={chartOptions(steel.sectionext, steel.unit)}
            />
          </div> */}
        </Col>
        <Col md={6}>
          <h2 className="subtitle">Shear</h2>
          <OutputCalc
            input={shear.VplRd}
            unitList={optionsForceUnits}
          />
          <OutputCalc
            input={shear.VedVplRd}
            unitList={optionsAutreUnits}
          />
          <OutputCalc
            input={shear.UnMoinsRho}
            unitList={optionsAutreUnits}
          />
        </Col>
      </Row>
    </Container>
  );
};


export default Shear;